import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const resetPassword = graphql(
  gql`
    mutation resetPassword($resetToken: String!, $email: String, $password: String!) {
      resetPassword(resetToken: $resetToken, email: $email, password: $password) {
        message
      }
    }
  `,
  {
    name: 'changeResetPassword'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ResetPassword/data.ts